import { useEffect, useState } from "react";
import { invoke } from "@tauri-apps/api/core";
import { Dialog, DialogContent, DialogTitle } from "@link/ui";
import { readSessionToken } from "../../lib/http";
import { StaffApproval } from "./StaffApproval";

/** Keep the current chat/call mounted; never navigate the app to approve. */
export function DesktopStaffApproval() {
  const [flow, setFlow] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (!(window as unknown as { __LINK_DESKTOP__?: { staffLogin?: boolean } }).__LINK_DESKTOP__?.staffLogin) return;
    let active = true, checking = false;
    const poll = async () => {
      if (checking || !readSessionToken()) return;
      checking = true;
      try {
        const pending = await invoke<{ flow_id: string } | null>("staff_login", { operation: "pending" });
        if (active) setFlow(pending?.flow_id ?? null);
      } catch { /* Older desktop builds do not expose this bridge. */ }
      finally { checking = false; }
    };
    void poll(); const timer = window.setInterval(() => void poll(), 1500);
    return () => { active = false; window.clearInterval(timer); };
  }, []);
  const close = async (sent = false) => {
    if (!flow || busy) return;
    setBusy(true);
    try {
      if (!sent) await invoke("staff_login", { operation: "cancel", flowId: flow }).catch(() => {});
      await invoke("staff_login", { operation: "dismiss", flowId: flow });
    } finally { setFlow(null); setBusy(false); }
  };
  return <Dialog open={!!flow} onOpenChange={open => { if (!open) void close(); }}>
    <DialogContent aria-describedby={undefined} className="max-w-lg border-0 bg-transparent p-0 shadow-none [&>button]:hidden" onEscapeKeyDown={event => event.preventDefault()} onPointerDownOutside={event => event.preventDefault()}>
      <DialogTitle className="sr-only">Approve admin sign-in</DialogTitle>
      {flow && <StaffApproval key={flow} desktopFlow={flow} onClose={sent => void close(sent)} onBusyChange={setBusy} />}
    </DialogContent>
  </Dialog>;
}
